import fetch from 'unfetch';

const getBars = async (email, code) => {
	const url = `/api/fetchRelevantData`;
	const res = await fetch(url, {
		method: 'POST',
		headers: {
			'content-type': 'application/json',
			authorization: localStorage.getItem('auth'),
		},
		body: JSON.stringify({
			email: email,
			code: code,
		}),
	});

	if (res.ok) {
		return { status: 'success', data: await res.json() };
	} else {
		return { status: 'error', data: await res.json() };
	}
};
export default getBars;
